module.exports = __webpack_public_path__ + "static/GudJob-c94017070746b805788f87ebbb68d432.svg";